import React from 'react';
import PropTypes from 'prop-types';
import MemberSectionPanel from '../../shared/component/MemberSectionPanel';
import DataTableWithButton from '../../shared/component/dataTable/DataTableWithButton';
import OrderItemsReadOnlyColumn from '../../shared/component/dataTable/columns/OrderItemsReadOnlyColumn.json';
import {MemberOrderSummaryFields} from '../storemanagement/OrderDetailFields';
import MemberOrderActionFooter from './MemberOrderActionFooter';
import GeneralUtils from '../../shared/utils/GeneralUtils';
import './orderPlacedConfirmation.css';
import './myOrders.css';

export default function OrderPlacedConfirmation({order, onContinueShopping}) {
    if (!order) {
        return null;
    }

    const items = Array.isArray(order.basketDetailList) ? order.basketDetailList : [];
    const storeName = order.tradingName || GeneralUtils.getMemberStoreTradingName();
    const footerActions = [
        {
            key: 'continue',
            label: 'Continue Shopping',
            icon: 'storefront',
            onClick: onContinueShopping,
            className: 'member-order-action-btn--primary',
        },
    ];

    if (GeneralUtils.isAuthenticated()) {
        footerActions.push({
            key: 'my-orders',
            label: 'My Orders',
            icon: 'receipt_long',
            onClick: () => {
                window.location.href = '/myOrders';
            },
            outline: true,
            className: 'member-order-action-btn--secondary',
        });
    }

    return (
        <div className="order-placed-confirmation member-order-detail member-order-detail--sticky-footer member-order-detail--page">
            <div className="member-order-detail__scroll">
                <div className="order-placed-confirmation__banner" role="status">
                    <i className="material-icons order-placed-confirmation__banner-icon" aria-hidden="true">check_circle</i>
                    <div className="order-placed-confirmation__banner-body">
                        <h1 className="order-placed-confirmation__title">Your order has been placed</h1>
                        <p className="order-placed-confirmation__subtitle">
                            Thank you. We have received your order.
                        </p>
                        {!GeneralUtils.isNullOrEmpty(storeName) && (
                            <p className="order-placed-confirmation__store">
                                <i className="material-icons order-placed-confirmation__store-icon" aria-hidden="true">storefront</i>
                                <span>{storeName}</span>
                            </p>
                        )}
                    </div>
                </div>

                <MemberSectionPanel title="Order Summary" sectionId="order-placed-summary">
                    <MemberOrderSummaryFields order={order} showPrices={true} showPaymentType={true}/>
                </MemberSectionPanel>

                {items.length > 0 && (
                    <MemberSectionPanel title="Items" sectionId="order-placed-items">
                        <DataTableWithButton
                            data={items}
                            className="order-detail-items-table checkout-order-table"
                            selectionMode="single"
                            paginator={false}
                            fields={OrderItemsReadOnlyColumn.fields}
                        />
                    </MemberSectionPanel>
                )}
            </div>

            <MemberOrderActionFooter actions={footerActions} />
        </div>
    );
}

OrderPlacedConfirmation.propTypes = {
    order: PropTypes.object,
    onContinueShopping: PropTypes.func.isRequired,
};
